import React from 'react'
import Icon from '@/components/Icon'
import { Link } from 'react-router-dom'
import Resx from '@/components/Resx'
import { format } from '@/utils/StringUtilities'

const ErrorItem = ({ item, localize }) => {
  return (
    <div>
      {format(localize(item.textFormat), item.textParam)}
      {item.url && <Link target='_blank' to={item.url}><Icon name='chevrons-right' /><Resx name={item.urlText || 'Common.Details'} /></Link>}
    </div>
  )
}
const ErrorDetails = ({ data, localize }) => {
  if (data && data.errorDetails) {
    return (
      <div style={{ width: '100%' }}>
        <span className='error-details'>
          <Icon name='error' />&nbsp;
          <span className='filename-and-lang'>
            {data.errorDetails.map((x, idx) => <ErrorItem key={idx} item={x} localize={localize} />)}
          </span>
        </span>
      </div>
    )
  }
  return null
}

export {
  ErrorDetails
}



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/errorDetails.js